import { useAuth, overrideConfig } from '@/api/billing-primary'

const fetchAllConsolidatedProductDetail = function ({ qtype, projectIdx, groupIdx, month, productCodes }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    let params = {
        qtype,
        groupIdx: qtype === 'project' || qtype === 'all' ? null : groupIdx,
        projectIdx: qtype === 'group' || qtype === 'all' ? null : projectIdx,
        month,
        productCodes
    }
    return auth.axiosIns.post('/v1/context', { target: 'AllConsolidatedProductDetail', params })
}
export default {
    fetchAllConsolidatedProductDetail
}
